import type { ModalProps as AntModalProps } from 'antd';
import Modal from './Modal';
import { Row } from '../Box';
import { Text } from '../Text';
import { IcClose } from 'basic-ui-lib/icons';
import styled from 'styled-components';
import { Colors } from 'basic-ui-lib/constants';
import { Button } from '../Button';
interface ModalProps extends AntModalProps {
  title: string;
  className?: string;
  closeOnClickOutside?: boolean;
  isOpen?: boolean;
  width?: string | number;
  onClose?: () => void;
}

const BaseModal = ({ title, className, closeOnClickOutside, isOpen, width, children, onClose, okText, onOk }: ModalProps) => {
  return (
    <Modal isOpen={isOpen} title={title} className={className} closeOnClickOutside={closeOnClickOutside} width={width}>
      <Row padding={24} justifyContent='center' alignItems='center' gap={16}>
        <Text title_h5 semibold>{title}</Text>
        <ButtonClose onClick={onClose}>
          <IcClose />
        </ButtonClose>
      </Row>
      {children}
      <FooterActions>
        <Button type_second lg onClick={onOk}>
          {okText || 'Confirm'}
        </Button>
      </FooterActions>
    </Modal>
  );
};

export default BaseModal;

const FooterActions = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  border-top: 1px solid ${Colors.neutral.border[1]};

  .type_second {
    min-width: 240px;
  }
`;

const ButtonClose = styled.button`
  position: absolute;
  top: 24px;
  right: 24px;
  background: none;
  border: none;
  cursor: pointer;
`;